// Web-only strings for áreas (shared/API.md §37), «En llamada» (§38), «Viendo ahora» (§39) and the
// live Core cards' footer (§40), BOTH
// languages. «En llamada» itself is NOT here: it is the wire text other people read, Spanish on every
// UI language (core/callStatusClaim.ts).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.area.groupByArea': 'Agrupar por área',
    'web.area.groupByArea.footer': 'Divide los mensajes directos por el área de cada persona. Se guarda solo en este navegador.',
    'web.area.listSection': 'Lista de conversaciones',
    'web.area.others': 'Otros',
    'web.area.messageArea': 'Mensaje a un área',
    'web.area.pickerTitle': 'Mensaje a un área',
    'web.area.search': 'Buscar un área',
    'web.area.empty': 'No hay áreas en este equipo.',
    'web.area.noMatches': 'Ningún área coincide con «%@».',
    'web.area.failed': 'No se pudieron cargar las áreas.',
    'web.area.joinFailed': 'No se pudo entrar al canal del área.',
    'web.area.yours': 'Tu área',
    'web.area.peopleOne': '1 persona',
    'web.area.people': '%d personas',
    'web.viewing.now': 'Viendo ahora: %@',
    'web.viewing.more': '+%d',
    'web.viewing.dm': 'Viendo el chat',
    'web.coreCard.updatedNow': 'Actualizado hace un momento',
    'web.coreCard.updatedMinutes': 'Actualizado hace %d min',
    'web.coreCard.updatedHours': 'Actualizado hace %d h',
    'web.coreCard.updatedDays': 'Actualizado hace %d d',
  },
  en: {
    'web.area.groupByArea': 'Group by area',
    'web.area.groupByArea.footer': 'Splits direct messages by each person’s area. Saved in this browser only.',
    'web.area.listSection': 'Conversation list',
    'web.area.others': 'Others',
    'web.area.messageArea': 'Message an area',
    'web.area.pickerTitle': 'Message an area',
    'web.area.search': 'Find an area',
    'web.area.empty': 'There are no areas in this team.',
    'web.area.noMatches': 'No area matches “%@”.',
    'web.area.failed': 'The areas could not be loaded.',
    'web.area.joinFailed': 'Could not join the area’s channel.',
    'web.area.yours': 'Your area',
    'web.area.peopleOne': '1 person',
    'web.area.people': '%d people',
    'web.viewing.now': 'Viewing now: %@',
    'web.viewing.more': '+%d',
    'web.viewing.dm': 'Viewing the chat',
    'web.coreCard.updatedNow': 'Updated just now',
    'web.coreCard.updatedMinutes': 'Updated %d min ago',
    'web.coreCard.updatedHours': 'Updated %d h ago',
    'web.coreCard.updatedDays': 'Updated %d d ago',
  },
};
